/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrentCompanyBasicInfo
 */
export interface CurrentCompanyBasicInfo {
    /**
     * 企業ID
     * @type {number}
     * @memberof CurrentCompanyBasicInfo
     */
    companyId: number;
    /**
     * 企業名
     * @type {string}
     * @memberof CurrentCompanyBasicInfo
     */
    companyName: string;
    /**
     * ファイルリソースが保存されたオンプレのURL
     * @type {string}
     * @memberof CurrentCompanyBasicInfo
     */
    companyLogoUrl: string | null;
    /**
     * 個人事業主フラグ
     * @type {boolean}
     * @memberof CurrentCompanyBasicInfo
     */
    isSoleProprietorship: boolean;
    /**
     * 企業が登録しているプラン名
     * @type {string}
     * @memberof CurrentCompanyBasicInfo
     */
    planName: string;
    /**
     * 企業が当日にリリースを作成しているかどうか
     * @type {boolean}
     * @memberof CurrentCompanyBasicInfo
     */
    isExistsTodayRelease: boolean;
    /**
     * スタートアップチャレンジ対象フラグ。https://github.com/PRTIMES/prtimes/blob/4be04c3f639b205bc8911e3af4b1f4cac07b4297/htdocs/inc/PRTIMES/PrTimes/Service/PressReleaseEditor/GetStartupChallengeStatusService.php#L71C13-L78
     * @type {boolean}
     * @memberof CurrentCompanyBasicInfo
     */
    isStartupCompany: boolean;
}

/**
 * Check if a given object implements the CurrentCompanyBasicInfo interface.
 */
export function instanceOfCurrentCompanyBasicInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "companyLogoUrl" in value;
    isInstance = isInstance && "isSoleProprietorship" in value;
    isInstance = isInstance && "planName" in value;
    isInstance = isInstance && "isExistsTodayRelease" in value;
    isInstance = isInstance && "isStartupCompany" in value;

    return isInstance;
}

export function CurrentCompanyBasicInfoFromJSON(json: any): CurrentCompanyBasicInfo {
    return CurrentCompanyBasicInfoFromJSONTyped(json, false);
}

export function CurrentCompanyBasicInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentCompanyBasicInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'companyLogoUrl': json['company_logo_url'],
        'isSoleProprietorship': json['is_sole_proprietorship'],
        'planName': json['plan_name'],
        'isExistsTodayRelease': json['is_exists_today_release'],
        'isStartupCompany': json['is_startup_company'],
    };
}

export function CurrentCompanyBasicInfoToJSON(value?: CurrentCompanyBasicInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'company_name': value.companyName,
        'company_logo_url': value.companyLogoUrl,
        'is_sole_proprietorship': value.isSoleProprietorship,
        'plan_name': value.planName,
        'is_exists_today_release': value.isExistsTodayRelease,
        'is_startup_company': value.isStartupCompany,
    };
}

